
<template lang="html">
    <!--<v-container style="padding-top: 100px;">-->
    <div>
        
        <v-row>
            <v-col lg=12 cols=12 style="margin: 0 auto;">
                <v-card>
                    <v-card-title class="pa-5 pb-3 primary">
                        <v-icon class="pr-4" :color="'#FFFFFF'">mdi-calendar-clock</v-icon>
                        <p style="color: white;">{{title}}</p>
                        <v-spacer></v-spacer>
                    </v-card-title>
                    <v-card-text class="pa-5 pt-4">


                        <v-row>
                            <v-col md="6" offset-md="3">
                                <span style="font-weight: bold;">Tipo Cita:</span>
                                <multiselect v-model="tipoCita.tpcclave"
                                             deselect-label="No se puede remover el valor seleccionado"
                                             selected-label="Seleccionado"
                                             select-label="Seleccione tipo de cita"
                                             track-by="tpcclave" label="tpcnombre"
                                             placeholder="Seleccione una opción"
                                             :options="tipoCita.opcionesCita"
                                             :allow-empty="false">
                                </multiselect>

                                <span v-if="validatpcclave" class='spanError' style='color:red;font-size:11px'>Campo requerido</span>
                            </v-col>
                        </v-row>
                        <v-form ref="form1"
                                v-model="valid1"
                                lazy-validation>
                            
                            <v-row class="mb-6" style="margin-bottom: 0px !important; height: 75px;">

                                <v-col md="3"
                                       offset-md="3">
                                    <span style="font-weight: bold;">Fecha Inicio:</span>
                                    <v-dialog ref="dialog"
                                              outlined
                                              v-model="modal"
                                              :return-value.sync="fechaInicio"
                                              persistent
                                              width="290px">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field v-model="fechaInicioV"
                                                          label=""
                                                          readonly
                                                          :rules="rulestextfechas"
                                                          outlined
                                                          dense
                                                          v-bind="attrs"
                                                          v-on="on"></v-text-field>
                                        </template>
                                        <v-date-picker v-model="fechaInicio"
                                                       locale="es-mx"
                                                       :min="minDateFhIni"
                                                       scrollable>
                                            <v-spacer></v-spacer>
                                            <v-btn text
                                                   color="primary"
                                                   @click="modal = false">
                                                Cancel
                                            </v-btn>
                                            <v-btn text
                                                   color="primary"
                                                   @click="$refs.dialog.save(fechaInicio)">
                                                OK
                                            </v-btn>
                                        </v-date-picker>
                                    </v-dialog>

                                </v-col>
                                <v-col md="3">
                                    <span style="font-weight: bold;">Hora Inicio:</span>

                                    <v-dialog ref="dialog1"
                                              v-model="modal2"
                                              outlined
                                              :return-value.sync="timeInicio"
                                              persistent
                                              width="290px">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field v-model="timeInicio"
                                                          label=""
                                                          readonly
                                                          :rules="rulestextfechas"
                                                          outlined
                                                          dense
                                                          :disabled="disabledtimeInicio"
                                                          v-bind="attrs"
                                                          v-on="on"></v-text-field>
                                        </template>
                                        <v-time-picker v-if="modal2"
                                                       v-model="timeInicio"
                                                       :min="mintimeInicio"
                                                       format="24hr"
                                                       ampm-in-title
                                                       scrollable
                                                       full-width>
                                            <v-spacer></v-spacer>
                                            <v-btn text
                                                   color="primary"
                                                   @click="modal2 = false">
                                                Cancel
                                            </v-btn>
                                            <v-btn text
                                                   color="primary"
                                                   @click="$refs.dialog1.save(timeInicio)">
                                                OK
                                            </v-btn>
                                        </v-time-picker>
                                    </v-dialog>
                                </v-col>
                               
                            </v-row>





                            <v-row class="mb-6" v-if="presencial" style="margin-bottom: 0px !important; height: 90px;">

                                <v-col md="3"
                                       offset-md="3">
                                    <span style="font-weight: bold;">Fecha Fin:</span>
                                    <v-dialog ref="dialog3"
                                              v-model="modal3"
                                              :return-value.sync="fechaFin"
                                              persistent
                                              outlined
                                              width="290px">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field v-model="fechaFinV"
                                                          label=""
                                                          readonly
                                                          :disabled="disabledfhfin"
                                                          :rules="rulestextfechas"
                                                          outlined
                                                          dense
                                                          v-bind="attrs"
                                                          v-on="on"></v-text-field>
                                        </template>
                                        <v-date-picker v-model="fechaFin"
                                                       locale="es-mx"
                                                       :min="minDateFhFin"
                                                       scrollable>
                                            <v-spacer></v-spacer>
                                            <v-btn text
                                                   color="primary"
                                                   @click="modal3 = false">
                                                Cancel
                                            </v-btn>
                                            <v-btn text
                                                   color="primary"
                                                   @click="$refs.dialog3.save(fechaFin)">
                                                OK
                                            </v-btn>
                                        </v-date-picker>
                                    </v-dialog>

                                </v-col>
                                <v-col md="3">
                                    <span style="font-weight: bold;">Hora Fin:</span>

                                    <v-dialog ref="dialog4"
                                              v-model="modal4"
                                              :return-value.sync="timeFin"
                                              persistent
                                              outlined
                                              width="290px">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field v-model="timeFin"
                                                          label=""
                                                          :disabled="disabledfhfin"
                                                          :rules="rulestextfechas"
                                                          readonly
                                                          outlined
                                                          dense
                                                          v-bind="attrs"
                                                          v-on="on"></v-text-field>
                                        </template>
                                        <v-time-picker v-if="modal4"
                                                       v-model="timeFin"
                                                       :min="mintimeFin"
                                                       format="24hr"
                                                       scrollable
                                                       ampm-in-title
                                                       full-width>
                                            <v-spacer></v-spacer>
                                            <v-btn text
                                                   color="primary"
                                                   @click="modal4 = false">
                                                Cancel
                                            </v-btn>
                                            <v-btn text
                                                   color="primary"
                                                   @click="$refs.dialog4.save(timeFin)">
                                                OK
                                            </v-btn>
                                        </v-time-picker>
                                    </v-dialog>
                                </v-col>
                                <br/>
    </v-row>
                        </v-form>

                        

                        <v-row>
                            <br />
                            <v-col md="6" offset-md="3">
                                <br />
                                <span style="font-weight: bold;">Comentarios:</span>

                                <v-form ref="form"
                                        v-model="valid"
                                        lazy-validation>
                                    <v-textarea @input="uppercase()"
                                                :counter="500"
                                                maxlength="500"
                                                :rules="rulestextarea"
                                                outlined
                                                v-model="comentarios"
                                                required
                                                name="input-7-4"></v-textarea>
                                </v-form>
                            </v-col>
                        </v-row>


                        <v-row justify="center" class="mb-8">

                            <v-btn v-if="pantalla=='A'"
                                   class="ma-2"
                                   color="primary"
                                   @click="GuardarCita()"
                                   :disabled="disabledSave">
                                Guardar
                            </v-btn>
                            <v-btn v-if="pantalla=='E'"
                                   class="ma-2"
                                   color="primary"
                                   @click="EditarCita()"
                                   :disabled="disabledSave">
                                Guardar
                            </v-btn>
                            <v-btn v-if="pantalla=='A'"
                                   class="ma-2"
                                   @click="limpiarCampos()"
                                   :disabled="disabledSave">
                                Limpiar
                            </v-btn>
                            <v-btn class="ma-2"
                                   color="error"
                                   @click="Cancelar()"
                                   :disabled="disabledSave">
                                Cancelar
                            </v-btn>
                        </v-row>
                        <div class="mt-10"><br><br><br><br></div>
                    </v-card-text>

                </v-card>
            </v-col>
        </v-row>
    </div>

    <!--</v-container>-->

</template>

<script>
    import { mapGetters, mapState } from 'vuex';
    import citas from '@/services/ControldeCitas/Citas.service.js';
    import moment from 'moment';
    export default {
        props: {
            nrreporte: '',
            svindice: '',
            aiclave: 0,
            pantalla: '',
            ciid:0
        },
        data: () => ({
            fechaInicioV: '',
            fechaFinV:'',
            date: '',
            timeInicio: '',
            timeFin: '',
            mintimeInicio: '',
            mintimeFin: '',
            modal: false,
            modal2: false,
            modal3: false,
            modal4: false,
            menu2: false,
                fe: '',
                menu: false,
                activePicker: null,
                options: {
                    format: 'DD/MM/YYYY h:mm:ss',
                    useCurrent: false,
                    showClear: true,
                    showClose: true,
                    widgetPositioning: {
                        vertical: 'bottom',
                        horizontal: 'left'
                    }
                },
            valid: true,
                valid1:true,
                validatpcclave: false,
                validafechaInicio: false,
                validafechaFin: false,
            rulestextarea: [v => !!v || 'Campo requerido',
            v => {
                if (v == null) {
                    return true
                }
                else {
                    // return 'Mínimo 12 Carácteres'

                    if (v.length < 12) {
                        return 'Mínimo 12 Carácteres'
                    }
                    else if (v.length > 500) {
                        return 'Máximo 500 Carácteres'
                    }
                    else
                        return true
                }
            },
            ],
                rulestextfechas: [v => !!v || 'Campo requerido'],
                title: '',
                disabledSave: false,
                carga: true,
                fechaInicio: '',
                fechaFin: '',
                disabledfhfin: true,
                minDateFhIni: '',
                minDateFhFin: '',
                tipoCita: {
                    opcionesCita: [],
                    tpcclave: '',
                    tpcnombre: ''
                },
                dataEditar: [],
                comentarios: '',
                counterDanger: false,
                presencial: true,
                count: 0,
            disabledtimeInicio: true,
            fechaInicio1: '',
            fechaFin1: '',
            back:0


            }),
        watch: {
            async 'tipoCita.tpcclave'(val) {
                this.validatpcclave = false;
                //cont++;
                if (val.tpcclave == 2) {
                    this.presencial = false;
                    this.minDateFhFin = '';
                    this.disabledfhfin = true;
                }
                else if (val.tpcclave == 1 && this.count == 1){
                    this.presencial = true;

                    this.fechaFin = this.fechaInicio;
                    this.minDateFhFin = this.fechaInicio;
                    if (this.fechaInicio != '') {
                        this.disabledfhfin = false;
                    }

                }
            },
            async 'fechaInicio'(val) {
                this.validafechaInicio = false;
                

                if ((val != null && val != '') && this.count == 1) {
                    
                    this.fechaFin = '';
                    this.timeInicio = '';
                    this.timeFin = '';
                    this.disabledtimeInicio = false;
                    this.fechaFin = val;
                    this.minDateFhFin = val;

                    moment.locale("es-mx");
                    let theDate = moment(val).format('ll');
                    this.fechaInicioV = theDate;
                    this.fechaFinV = theDate;

                    let fechad = new Date().toLocaleDateString('en-GB').split('/');
                    let fechahoy = fechad[2] + '-' + fechad[1] + '-' + fechad[0];


                    var fecha1 = moment(val, "YYYY-MM-DD HH:mm:ss");
                    var fecha2 = moment(fechahoy, "YYYY-MM-DD HH:mm:ss");

                    var startTime = new Date(fecha1);
                    var endTime = new Date(fecha2);
                    var difference = endTime.getTime() - startTime.getTime(); // This will give difference in milliseconds
                    var resultInMinutes = Math.round(difference / 60000);
                    let hours = new Date().getHours();
                    let minuts = new Date().getMinutes();
                    if (hours < 10) {
                        hours = "0" + hours;
                    }
                    if (minuts < 10) {
                        minuts = "0" + minuts;
                    }
                    if (resultInMinutes == 0) {
                        this.mintimeInicio = hours + ':' + minuts;
                    }
                    else {
                        this.mintimeInicio = '';
                    }
                }
                else {
                    this.disabledtimeInicio = false;

                }



            },
            async 'fechaFin'(val) {
                this.validafechaFin = false;

                if (this.count == 1) {
                    //this.timeFin = '';
                }
                if (val != null && val != '') {
                    moment.locale("es-mx");
                    let theDate = moment(val).format('ll');
                    this.fechaFinV = theDate;

                    var fecha1 = moment(this.fechaInicio, "YYYY-MM-DD HH:mm:ss");
                    var fecha2 = moment(val, "YYYY-MM-DD HH:mm:ss");

                    var startTime = new Date(fecha1);
                    var endTime = new Date(fecha2);
                    var difference = endTime.getTime() - startTime.getTime(); // This will give difference in milliseconds
                    var resultInMinutes = Math.round(difference / 60000);
                    
                    if (resultInMinutes == 0) {
                        this.mintimeFin = this.timeInicio;
                    }
                    else {
                        this.mintimeFin = '';
                    }


                }
                else {
                    this.fechaFin = '';
                    this.minDateFhFin = '';
                }
            },

            async 'timeInicio'(val) {
                this.disabledfhfin = false;

                if (this.count == 1) {
                    this.timeFin = '';
                }
                if (val != null || val != '') {
                    var fechaInit = moment(this.fechaInicio+' '+val, "YYYY-MM-DD HH:mm:ss");
                    var newfechaInit = fechaInit.add(moment.duration("01:00:00"));


                    this.fechaFin = newfechaInit.format("YYYY-MM-DD");
                    this.timeFin = newfechaInit.format("HH:mm");



                    var fecha1 = moment(this.fechaInicio, "YYYY-MM-DD HH:mm:ss");
                    var fecha2 = moment(this.fechaFin, "YYYY-MM-DD HH:mm:ss");

                    var startTime = new Date(fecha1);
                    var endTime = new Date(fecha2);
                    var difference = endTime.getTime() - startTime.getTime(); // This will give difference in milliseconds
                    var resultInMinutes = Math.round(difference / 60000);
                    
                    if (resultInMinutes == 0) {
                        this.mintimeFin = this.timeInicio;
                    }
                    else {
                        this.mintimeFin = '';
                    }


                }

            },
            async 'timeFin'(val) {
            }
        },


        computed: {
            ...mapGetters(['getUser', 'THEME_STATE']),
            ...mapState({ drawer: state => state.drawer }),
            ...mapState(['domain', 'informationPage', 'permission']),
            DRAWER_STATE: {
                get() {
                    return this.drawer
                },
            }
        },
        methods: {
            async GuardarCita() {
                this.comentarios = this.comentarios.trim();
                this.$refs.form.validate();
                this.$refs.form1.validate();
                this.disabledSave = true;
                let mensajefhIni = this.fechaInicio == '' ? 'Seleccione la Fecha/Hora de Inicio.</br></br>' : '';
                let mensajefhFin = '';
                if (this.tipoCita.tpcclave.tpcclave == 1) {
                    mensajefhFin = this.fechaFin == '' ? 'Seleccione la Fecha/Hora Fin.</br></br>' : '';
                }


                let mensajetipCita = this.tipoCita.tpcclave == '' ? 'Seleccione el tipo de Cita.</br></br>' : '';
                let mensajeComentario = this.comentarios.length < 12 ? 'Ingrese Comentario mínimo 12 carácteres.</br></br>' : '';

                
                if (this.valid == true && this.$refs.form1.validate() && mensajetipCita == '' && mensajeComentario == '') {

                    var fecha1 = moment(this.fechaInicio + this.timeInicio, "YYYY-MM-DD HH:mm:ss");
                    var fecha2 = moment(this.fechaFin + this.timeFin, "YYYY-MM-DD HH:mm:ss");

                    var startTime = new Date(fecha1);
                    var endTime = new Date(fecha2);
                    var difference = endTime.getTime() - startTime.getTime(); // This will give difference in milliseconds
                    var resultInMinutes = Math.round(difference / 60000);

                    this.fechaInicio1 = this.fechaInicio +' '+ this.timeInicio;
                    this.fechaFin1 = this.fechaFin + ' ' + this.timeFin;


                    if ((this.tipoCita.tpcclave.tpcclave == 1 && resultInMinutes >= 30) || this.tipoCita.tpcclave.tpcclave == 2) {


                        await citas.validarCita(this).then(response => {

                            if (!response) {
                                this.$swal({
                                    position: 'center',
                                    title: 'Guardando Cita, espere un momento....',
                                    allowEscapeKey: false,
                                    allowOutsideClick: false,
                                    didOpen: () => {
                                        this.$swal.showLoading();
                                    }
                                });

                

                                citas.guardarCita(this).then(response2 => {
                                    

                                    this.$swal.close();

                                    if (response2) {
                                        this.$swal({
                                            position: 'center',
                                            icon: 'success',
                                            title: 'Éxito',
                                            text: 'Se guardó la cita con éxito.',
                                            showConfirmButton: true,
                                            timer: 3000
                                        }).then((result) => {
                                            if (result.isConfirmed) {
                                                this.back = 1;
                                                this.limpiarCampos();
                                                this.disabledSave = false;
                                                this.$emit("cambio", true);
                                            } 
                                        })

                                        setTimeout(() => {
                                            if (this.back == 0) {
                                                this.limpiarCampos();
                                                this.disabledSave = false;
                                                this.$emit("cambio", true);
                                            }
                                            

                                        }, 3000);


                                    }
                                });

                            }
                            else {
                                this.disabledSave = false;
                                this.$swal({
                                    position: 'center',
                                    icon: 'error',
                                    title: 'Ya existe otra cita agendada en la fecha y hora selecionada.',
                                    showConfirmButton: true,
                                });
                            }
                            
                        });

                    }
                    else {
                        this.disabledSave = false;
                        this.$swal({
                            position: 'center',
                            icon: 'error',
                            title: 'El tiempo mínimo de una cita debe ser de 30 minutos',
                            showConfirmButton: true,
                        });
                    }



                }
                else {
                    this.disabledSave = false;
                    if (mensajetipCita != '') {
                        this.validatpcclave = true;
                    }
                    if (mensajefhIni != '') {
                        this.validafechaInicio = true;
                    }
                    if (mensajefhFin != '') {
                        this.validafechaFin = true;
                    }
                    

                }



            },
            Cancelar() {
                this.$emit("cambio", true);
            },
            limpiarCampos() {
                this.$refs.form1.reset();
                this.$refs.form.reset();
                this.disabledtimeInicio = true;
                this.timeInicio = '';
                this.timeFin = '';
                this.mintimeInicio = '';
                this.mintimeFin = '';
                this.fechaInicioV = '';
                this.fechaFinV = '';
                this.fechaInicio = '';
                this.fechaFin = '';
                
                this.minDateFhFin = '';
                this.disabledfhfin = true;
                this.tipoCita.tpcclave = '';
                this.comentarios = '';
                this.tpcnombre = '';
                this.validatpcclave = false;
                this.validafechaInicio = true;
                this.validafechaFin = true;


            },
            uppercase() {
                if (this.comentarios != '' && this.comentarios != null) {
                    this.comentarios = this.comentarios.toUpperCase();
                }

            },

            async EditarCita() {
                this.comentarios = this.comentarios.trim();
                this.$refs.form.validate();
                this.$refs.form1.validate();
                this.disabledSave = true;
                let mensajefhIni = this.fechaInicio == '' ? 'Seleccione la Fecha/Hora de Inicio.</br></br>' : '';
                let mensajefhFin = '';
                let horafin = '';
                if (this.tipoCita.tpcclave.tpcclave == 1) {
                    mensajefhFin = this.fechaFin == '' ? '1' : '';
                    horafin = this.timeFin == '' ? '1' : '';
                }


                let mensajetipCita = this.tipoCita.tpcclave == '' ? 'Seleccione el tipo de Cita.</br></br>' : '';
                let mensajeComentario = this.comentarios.length < 12 ? 'Ingrese Comentario mínimo 12 carácteres.</br></br>' : '';

                if (this.valid == true && mensajefhFin == '' && horafin=='' && this.timeInicio!='' && this.fechaFin!='' && this.$refs.form1.validate() && mensajetipCita == '' && mensajeComentario == '' ) {

                    var fecha1 = moment(this.fechaInicio + this.timeInicio, "YYYY-MM-DD HH:mm:ss");
                    var fecha2 = moment(this.fechaFin + this.timeFin, "YYYY-MM-DD HH:mm:ss");

                    var startTime = new Date(fecha1);
                    var endTime = new Date(fecha2);
                    var difference = endTime.getTime() - startTime.getTime(); // This will give difference in milliseconds
                    var resultInMinutes = Math.round(difference / 60000);

                    this.fechaInicio1 = this.fechaInicio + ' ' + this.timeInicio;
                    this.fechaFin1 = this.fechaFin + ' ' + this.timeFin;

                    if ((this.tipoCita.tpcclave.tpcclave == 1 && resultInMinutes >= 30) || this.tipoCita.tpcclave.tpcclave == 2) {
                        
                        await citas.validarCitaEditar(this).then(response => {

                            if (!response) {
                                
                                this.$swal({
                                    position: 'center',
                                    title: 'Editando Cita, espere un momento....',
                                    allowEscapeKey: false,
                                    allowOutsideClick: false,
                                    didOpen: () => {
                                        this.$swal.showLoading();
                                    }
                                });

                                citas.guardarEdicionCita(this).then(response2 => {
                                   

                                    this.$swal.close();

                                    if (response2) {
                                        
                                        this.$swal({
                                            position: 'center',
                                            icon: 'success',
                                            title: 'Éxito',
                                            text: 'Se editó la cita con éxito.',
                                            showConfirmButton: true,
                                            timer: 3000
                                        }).then((result) => {
                                            if (result.isConfirmed) {
                                                this.back = 1;
                                                this.limpiarCampos();
                                                this.disabledSave = false;
                                                this.$emit("cambio", true);
                                            }
                                        })

                                        setTimeout(() => {
                                            if (this.back ==0 ) {
                                                this.limpiarCampos();
                                                this.disabledSave = false;
                                                this.$emit("cambio", true);
                                            }
                                        }, 3000);


                                    }
                                });

                            }
                            else {
                                this.disabledSave = false;
                                
                                this.$swal({
                                    position: 'center',
                                    icon: 'error',
                                    title: 'Ya existe otra cita agendada en la fecha y hora selecionada.',
                                    showConfirmButton: true,
                                });
                            }
                        });

                    }
                    else {
                        this.disabledSave = false;
                        this.$swal({
                            position: 'center',
                            icon: 'error',
                            title: 'El tiempo mínimo de una cita debe ser de 30 minutos',
                            showConfirmButton: true,
                        });

                    }



                }
                else {
                    this.disabledSave = false;
                    if (mensajetipCita != '') {
                        this.validatpcclave = true;
                    }
                    if (mensajefhIni != '') {
                        this.validafechaInicio = true;
                    }
                    if (mensajefhFin != '') {
                        this.validafechaFin = true;
                    }

                }
            }
        },
        async mounted() {

            this.title = this.pantalla != 'A' ? 'Editar Cita' : 'Alta de Cita';


            
            if (this.pantalla == 'E') {
                await citas.obtenerdataEditar(this).then(response => {
                    this.dataEditar = response;
                    this.count = 0;
                    this.tipoCita.tpcclave = { tpcclave: response[0].tpcclave, tpcnombre: response[0].tpcnombre };       

                    var telfinicio = response[0].fechaInicio.split(" ");
                    this.fechaInicio = telfinicio[0];
                    this.timeInicio = telfinicio[1];
                    let theDate = moment(telfinicio[0]).format('ll');
                    this.fechaInicioV = theDate;


                    var telffin = response[0].fechaFin.split(" ");
                    this.fechaFin = telffin[0];
                    this.timeFin = telffin[1];
                    

                    setTimeout(() => {
                        //this.minDateFhFin = response[0].fechaInicio;
                       
                    }, 2000);
                    

                    if (response[0].tpcclave==2) {
                        this.presencial = false;
                        this.minDateFhFin = '';
                        this.disabledfhfin = true;
                    }
                    this.comentarios = response[0].comentarios;
                    

                    setTimeout(() => {
                        this.count = 1;

                    }, 2000);


                    //this.show = false;

                });
            }
            if (this.pantalla == 'A') {
                    this.count = 1;


            }

            await citas.obtenerFechaActual(this).then(response => {
                this.minDateFhIni = response[0].today;


            });

            let fechad = new Date().toLocaleDateString('en-GB').split('/');
            let hours = new Date().getHours();
            let minuts = new Date().getMinutes();
            if (hours < 10) {
                hours = "0" + hours;
            }
            if (minuts < 10) {
                minuts = "0" + minuts;
            }

            
            citas.obtenerTipoCita(this);
        }
    }
</script>

<sytle>
    .dropdown-menu{
    width:250px !important;
    }
</sytle>

